/* ===============================
   SHOP BY COLLECTION – VIDEO HOVER (FINAL FIX)
   WORKS WITH AJAX / RECOMMENDATIONS
   =============================== */

document.addEventListener('mouseover', function (e) {
  const card = e.target.closest('.product-card.video-card');
  if (!card) return;

  const video = card.querySelector('.card-video');
  if (!video) return;

  if (video.readyState >= 2) {
    video.play().catch(() => {});
  } else {
    video.addEventListener(
      'canplay',
      () => {
        video.play().catch(() => {});
      },
      { once: true }
    );
  }
});

document.addEventListener('mouseout', function (e) {
  const card = e.target.closest('.product-card.video-card');
  if (!card) return;

  const video = card.querySelector('.card-video');
  if (!video) return;

  video.pause();
  video.currentTime = 0;
});